<div [className]="'amp-progress-bar-wrapper ' + color">
    <span *ngIf="onlyBar == false" class="amp-progress-bar-label">{{ label }}</span>
    <div class="amp-progress-bar-bg" [ngClass]="{'progress-striped': stripes == true}">
        <div class="amp-progress-bar" [ngClass]="{'progress-bar': stripes, 'active': stripes}" [ngStyle]="{'width': + value +'%'}"></div>
    </div>  
    <span *ngIf="showPercentage" class="amp-progress-bar-value">{{ value | number: '1.0-0' }}%</span>  
</div>